if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.priceTarget = this.querySelector(`#StickyPrice-${this.sectionId}`);
        this.button = this.querySelector('.sticky-add-to-cart__button');
      }

      connectedCallback() {
        const observedButton = document.getElementById(this.dataset.observe);
        if (observedButton && 'IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
            rootMargin: '0px',
          });
          this.intersectionObserver.observe(observedButton);
        }

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          this.updateFromVariant(event.data.variant);
        });
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      handleIntersection(entries) {
        this.classList.toggle('sticky-add-to-cart--visible', !entries[0].isIntersecting);
      }

      updateFromVariant(variant) {
        const sourcePrice = document.getElementById(`price-${this.sectionId}`);
        if (sourcePrice && this.priceTarget) {
          this.priceTarget.innerHTML = sourcePrice.innerHTML;
        }

        if (!this.button) return;
        const unavailable = !variant || variant.available === false;
        this.button.toggleAttribute('disabled', unavailable);
        this.button.querySelector('span').textContent = unavailable
          ? window.variantStrings.soldOut
          : 'COMPRAR AHORA';
      }
    }
  );
}
